var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "rb-fieldrow": true,
        "rb-fieldrow-textarea": true,
        "rb-emptyrow": _vm.isEmptyRow,
        "rb-floating": _vm.isFloating,
        "rb-validrow": _vm.isValidRow || _vm.isFocus,
        "rb-invalidrow": _vm.isInValidRow,
      },
    },
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.value,
            expression: "value",
            modifiers: { trim: true },
          },
        ],
        ref: "field",
        attrs: {
          id: _vm.id,
          name: _vm.name,
          rows: _vm.rows,
          cols: _vm.cols,
          maxlength: _vm.maxlength,
          placeholder: _vm.placeholder,
          required: _vm.required,
          autocomplete: _vm.autocomplete,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.value },
        on: {
          focusin: _vm.onFocusIn,
          focusout: _vm.onFocusOut,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value = $event.target.value.trim()
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              class: { "rb-field--required": _vm.required },
              attrs: { for: _vm.id },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
              !_vm.required
                ? _c("span", { staticClass: "rb-field--optional" }, [
                    _vm._v(" " + _vm._s(_vm.labelOptional)),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.helper
        ? _c("span", { staticClass: "rb-fieldrow__helper" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.helperLabel.replace(_vm.ZERO_PLACEHOLDER, _vm.remainChars)
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }